export default __webpack_public_path__ + "static/media/customization_tool.a3ae6b2f.png";